import ProgressBar from '../components/widgets/progress-bar/progress-bar'
import Search from '../components/widgets/search/search'
import { dashboard } from '../dashboard/dashboard'
import { fundraisingPages } from '../fundraising-pages/fundraising-pages'
import HomePage from '../home-page/home-page'
import Leaderboard from '../leaderboard/leaderboard'
// import { leaderboard } from '../leaderboard/leaderboard'
import Registration, { registration } from '../registration/registration'

export const navigation = () => {
  createListener()
  handleHashChange()
}

const createListener = () => {
  let oldReplaceState = history.replaceState
  history.replaceState = function replaceState() {
    let ret = oldReplaceState.apply(this, arguments)
    window.dispatchEvent(new Event('replacestate'))
    return ret
  }
}

const handleHashChange = () => {
  window.addEventListener(
    'replacestate',
    () => {
      console.log('The hash has changed')
      registration()
      dashboard()
      fundraisingPages()

      new HomePage()
      new Leaderboard()
      new Registration()
      new Search()
      new ProgressBar()
    },
    false
  )
}
